"use client";

// Brand v2's shared entry point for the reviewed, RTL-adapted shadcn primitive.
// Keep screen consumers here so a future implementation swap has one owner.
/**
 * Brand v2 Component Contract — ButtonGroup (layout, not an action).
 * 1. Tokens: upstream semantic bg-muted/bg-input/border and shadow-xs;
 *    child controls retain their Brand tokens. Puck adds scoped --theme-* tokens.
 * 2. States: default/empty layout supported; hover/active/focus/disabled/loading/
 *    error belong to each child, never blocked or simulated by this container.
 * 3. RTL: logical inline corner/border utilities; vertical top/bottom unchanged.
 *    Direction and mixed-language content are inherited from the consumer.
 * 4. Motion: none; no animation or reduced-motion override needed here.
 * 5. Accessibility: role=group; consumer supplies accessible group name. Native
 *    child keyboard order/focus retained; decorative Radix separators. This is
 *    not a toolbar with arrow-key roving focus. Contrast remains consumer-owned.
 * 6. Skins: Quiet/Pro/Signature untested; no skin selection or global override.
 * 7. Themes: dark/light untested visually; semantic tokens are inherited.
 */
export { ButtonGroup, ButtonGroupText, ButtonGroupSeparator } from "@/components/shadcn/button-group";
